import { Vue, Options } from 'vue-class-component';
import { IThermoRoomObjectDTO } from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { SlotRuleServiceType } from '@/core/services/slots-assign-rules-service/slots-assign-rules-interfaces';
import { IDefaultDevicesSettingsDTO } from '@/../client-generator/generated-clients/device-settings';

@Options({
  name: 'ThermoGeneralStep',
  props: {
    roomObject: {
      type: Object as PropType<IThermoRoomObjectDTO>,
      required: true,
    },
    plantId: {
      type: Number,
      required: true,
    },
    roomId: {
      type: String,
      required: true,
    },
    roomName: {
      type: String,
      required: true,
    },
    roomType: {
      type: Number,
      required: true,
    },
    customParams: {
      type: Object as PropType<any>,
    },
    defaultSettings: {
      type: Object as PropType<IDefaultDevicesSettingsDTO[]>,
      required: true,
    },
  },
  emits: ['update:defaultSettings', 'next-enabled'],
  watch: {
    nextEnabled: function () {
      this.emitIsNextEnabled();
    },
  },
})
export default class ThermoGeneralStep extends Vue {
  defaultSettings!: IDefaultDevicesSettingsDTO[];
  roomObject!: IThermoRoomObjectDTO;
  plantId!: number;
  roomId!: string;
  roomName!: string;
  roomType!: number;
  customParams?: any;
  SlotRuleServiceType = SlotRuleServiceType;

  nextEnabled = true;

  emitIsNextEnabled() {
    this.$emit('next-enabled', this.nextEnabled);
  }
}
